import { Component, Inject, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule, JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { MtrwbService, templateUrlConfigMtr } from '../_service_mtr';
import { Mtrwb } from '../_entity_mtr';
import { JkRichEditorComponent } from 'jk-service';//'../components/jk-rich-editor/jk-rich-editor.component';

@Component({
  selector: 'app-mtrwb-edit',
  templateUrl: './mtrwb-editPkg.component.html',
  standalone: true,
  imports: [JackBaseComponentModule, AdvComModule, MaterialModule, JkRichEditorComponent, FormsModule, CommonModule],
})
export class MtrwbEditComponent extends JkDialogEditComponent<MtrwbService, Mtrwb> {
  override srv!: MtrwbService;

  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<MtrwbEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject, dialogRef, data);
    this.srv.cdr = this.cdr;
  }

  getImagePath(item: Mtrwb): string {
    return item.WB001 + '-' + item.WB002 || 'unknown';
  }

  toUpperCaseField(fieldName: 'WB006' | 'WB008', value: string): void {
    this.item[fieldName] = this.toUpperCaseValue(value);
  }

  override async doOk(e: any): Promise<boolean> {
    this.normalizeUpperCaseFields();
    return super.doOk(e);
  }

  private normalizeUpperCaseFields(): void {
    this.item.WB006 = this.toUpperCaseValue(this.item.WB006);
    this.item.WB008 = this.toUpperCaseValue(this.item.WB008);
  }

  private toUpperCaseValue(value: string): string {
    return (value || '').toUpperCase();
  }
  WB003Change(item: Mtrwb, newValue: string): void {
    setTimeout(async () => {
      await this.srv.WB003Change(item, newValue);
      this.cdr.detectChanges();
    });
  }
}
